module.exports = __webpack_public_path__ + "img/alfa-romeo_thumbnail.56a64158.png";